import { cn } from '@/lib/utils';
import { SpinnerRing } from './SpinnerRing';

interface LoadingSpinnerProps {
  fullScreen?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export function LoadingSpinner({
  fullScreen = false,
  className,
  size = 'lg',
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'size-6',
    md: 'size-8',
    lg: 'size-10',
    xl: 'size-14',
  };

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center bg-background',
        fullScreen ? 'fixed inset-0 h-screen w-screen z-50' : 'h-64 w-full',
        className
      )}
    >
      <div className="relative flex items-center justify-center">
        <SpinnerRing className={cn('z-10', sizeClasses[size])} />
      </div>
    </div>
  );
}
